export default {
  text: {
    default: 'Order directly through us for the fastest service, free rewards and help us save on fees',
    promo_code: {
      title: 'We thank you for ordering via our site',
      description_one: '🔥 {{discount}} discount - Code:',
      description_other: '🔥 {{discount}} discount on {{count}} orders - Code:',
    },
    copied_promo_code: 'Promo code copied to the clipboard',
  },
};
